import React from "react";
import { SelectContext } from "./Select";

interface SelectTriggerProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

export const SelectTrigger = React.forwardRef<
  HTMLButtonElement,
  SelectTriggerProps
>(({ className = "", children, ...props }, ref) => {
  const { isOpen, setIsOpen } = React.useContext(SelectContext);

  return (
    <button
      ref={ref}
      className={`flex h-10 w-full items-center justify-between rounded-md border border-gray-200 bg-white 
        px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus:outline-none button-hover-location ${className}`}
      onClick={() => setIsOpen(!isOpen)}
      type="button"
      {...props}
    >
      {children}
      <svg
        className={`h-4 w-4 opacity-50 transition-transform duration-200 ${
          isOpen ? "rotate-180 transform" : ""
        }`}
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>
  );
});
SelectTrigger.displayName = "SelectTrigger";